import { paginationOptions, navigationOptions } from "Config/slider/default"
import { productsSliderOptions } from "Config/slider/product"
import { indexSmallBannersSliderOptions, indexBannerSliderOptions } from "Config/slider/index"

import { rSwiperVisibleItems } from 'Functions/swiper-visible-items'
import { rSwiperCssNavFix } from 'Functions/swiper-css-nav-fix'
import { EffectFade, Navigation, Pagination, Autoplay } from 'swiper';


export const sliderOptions = instance => {
    // default options
    let options = {
        simulateTouch: false,
        watchOverflow: true,
        preventInteractionOnTransition: true,
        roundLengths: true,
        modules: [Pagination, Navigation, EffectFade, Autoplay, rSwiperVisibleItems, rSwiperCssNavFix]
    }

    if (instance.paginationEl) {
        options = {...options, ...paginationOptions(instance)}
    }

    if (instance.prevEl && instance.nextEl) {
        options = {...options, ...navigationOptions(instance)}
    }

    if (instance.hasAttribute('r-slider-products')) {
        const maxVisibleItems = instance.hasAttribute('r-max-visible-items') ? instance.getAttribute('r-max-visible-items') : 10
        options = {...options, ...productsSliderOptions(instance, options, maxVisibleItems)}
    }

    if (instance.hasAttribute('r-slider-index-small-banners')) {
        options = {...options, ...indexSmallBannersSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-index-banner')) {
        options = {...options, ...indexBannerSliderOptions(instance, options, instance.labels)}
    }

    return {...options, ...instance.customOptions}
}